
import { defineComponent, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { ApiPaymentResultResponse } from '@/contracts/api/ResponseContracts'
import { axiosPostPaymentResult } from '@/composables/api'

export default defineComponent(
{
    name: 'PayResult',
    setup()
    {
        // Load router:
        const router = useRouter()
        // Use vuex:
        const store = useStore()
        // Get authentication status:
        const isAuthenticated = store.getters['auth/isAuthenticated']
        // Get transaction reference from store:
        const transactionReference = store.getters['basket/getTransactionReference']

        // Check for transaction reference:
        if(!transactionReference)
        {
            store.commit('errors/setNuxeoErrors',
            {
                message: 'Payment error: No transaction reference found. Please try again.'
            })
            router.push({ hash: '#error-summary-container' })
        }
        else if(isAuthenticated)
        {
            // Call payment result endpoint:
            const resultData = axiosPostPaymentResult('/payment/result',
            {
                transactionReference: transactionReference
            })
            watch(resultData, (response: ApiPaymentResultResponse) =>
            {
                if(response.status === 500 || response.errorCode)
                {
                    store.commit('errors/setNuxeoErrors',
                    {
                        message: 'Error retrieving payment status. Your transaction reference is: ' + transactionReference
                    })
                    router.push({ hash: '#error-summary-container' })
                    return
                }
                if(response.transactionStatus !== undefined)
                {
                    // Route based on transaction status:
                    switch(response.transactionStatus)
                    {
                        case 'CAPTURED':
                            // Store payment result for PaySuccess:
                            store.commit('basket/setPaymentResult',
                            {
                                orderNumber: response.orderNumber || '',
                                transactionReference: response.transactionReference,
                                cardType: response.cardType || '',
                                settledDate: response.settledDate || ''
                            })
                            // The order is confirmed server-side by now (the
                            // proxy ran ConfirmOrderPayment and re-read the
                            // order status before answering), so refresh the
                            // header's My Orders badge — its boot-time read on
                            // this page load preceded the confirm. One orders
                            // read per confirmed payment.
                            store.commit('orders/markChanged')
                            router.push({ name: 'PaySuccess' })
                            break
                        case 'DECLINED':
                        case 'FAILED':
                            router.push({ name: 'PayDeclined' })
                            break
                        case 'CANCELLED':
                            router.push({ name: 'PayCanceled' })
                            break
                        default:
                            router.push({ name: 'PayException' })
                    }
                }
            })
        }

        // Return data:
        return {
            isAuthenticated
        }
    }
})
